<template>
  <section class="about-wrapper">
    <div class="vines"></div>
    <!-- ABOUT -->
    <div class="about-container">
      <div class="animated-text">
        <div class="container">
          <div class="text">I'm a</div>
          <ul>
            <li>traveller</li>
            <li class="animated-hide">cinema & video games fan</li>
            <li class="animated-show">geek</li>
            <li>rock climber</li>
            <li>bookworm</li>
          </ul>
        </div>
      </div>

      <table>
        <tr>
          <td width="45%" class="about-CV">
            <h2 class="wow fadeIn">
              I'm also a senior front-end developer and team lead with an eye for design
            </h2>
            <a href="CV.pdf" target="_blank" class="cy-CV">
              <div class="wow button rubberBand" data-wow-delay="1s">
                Download CV
              </div>
            </a>

            <div class="couch-container"></div>
            <div class="wow blink light"></div>
            <a href="CV.pdf" target="_blank" class="cy-CV"
              ><div class="wow eye-blink totoro-eyes"></div
            ></a>
          </td>

          <td width="55%" class="about-description wow fadeIn">
            <b>About me:</b> Originally from France and now based in the Brisbane area, I’m a front-end developer with a strong focus on building clean, accessible, and engaging web experiences. Over the past decade, I’ve worked across different countries and industries, combining design sensibility with technical problem-solving to bring ideas to life on the web.
            <br />
            <p>
              I enjoy working with modern frameworks like React and Vue, and I’m always exploring new ways to make the front-end more efficient and enjoyable to use. I’ve also led website migrations to headless architectures — most recently moving multiple WordPress sites at Mable to Contentful, a project with 1000+ pages, multiple teams, and a tight timeline.
            </p><p>
              Outside of work, I like reading, writing, binge-watching movies and shows, and occasionally defying gravity with aerial arts or rock climbing.
            </p>
          </td>
        </tr>
      </table>
    </div>

    <div class="about-floor"></div>
  </section>
</template>

<script type="ts" setup></script>
